"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplaceShoppingBagItemEvent = exports.Name = void 0;
const Name = exports.Name = 'replace-shopping-bag-item';
const ReplaceShoppingBagItemEvent = exports.ReplaceShoppingBagItemEvent = Name;
